import { makeAutoObservable } from 'mobx';
import { copyToClipboard } from '../../../utils/browser';

export default class PulseKey {
  createdAt?: Date;
  disabled?: boolean;
  downloadCount?: number;
  downloadIps: string[] = [];
  fulfilledAt?: Date;
  fulfillmentEmail?: string;
  key!: string;
  label?: string;
  redeemedAt?: Date;
  redemptionEmail?: string;
  redemptionIp?: string;
  sellableId!: string;
  status?: KeyStatus = 'unused';

  isSelected = false;

  static readonly redeemedStatuses: KeyStatus[] = [
    'downloaded',
    'downloading',
    'redeemed',
  ];

  constructor({ createdAt, fulfilledAt, redeemedAt, ...dto }: PulseKeyDto) {
    makeAutoObservable(this, {}, { autoBind: true });

    Object.assign(this, dto);

    this.createdAt = createdAt && new Date(createdAt);
    this.fulfilledAt = fulfilledAt && new Date(fulfilledAt);
    this.redeemedAt = redeemedAt && new Date(redeemedAt);
  }

  /** The key was either redeemed by the customer or sent to them. */
  get customerEmail(): string {
    return this.redemptionEmail || this.fulfillmentEmail || '';
  }

  get id(): string {
    return this.key;
  }

  get ipOfDownload(): string {
    return this.downloadIps.at(-1) || '';
  }

  setLabel(value: string) {
    this.label = value;
  }

  copyToClipboard() {
    copyToClipboard(this.key);
  }

  setDisabled(value: boolean) {
    this.disabled = value;
  }

  setDownloadCount(value: number) {
    this.downloadCount = value;
  }

  setSelected(value: boolean) {
    this.isSelected = value;
  }
}

export interface PulseKeyDto {
  createdAt?: Date;
  disabled?: boolean;
  downloadCount?: number;
  downloadIps?: string[];
  fulfilledAt?: Date;
  fulfillmentEmail?: string;
  key: string;
  label?: string;
  redeemedAt?: Date;
  redemptionEmail?: string;
  redemptionIp?: string;
  sellableId?: string;
  status?: KeyStatus;
}

export type KeyStatus =
  | 'downloaded'
  | 'downloading'
  | 'not redeemed'
  | 'redeemed'
  | 'unused';
